import React, { useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { DownFillIcon, DateIcon } from '~svg/index';
import { Button, DatePicker } from '../../../component';
import { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '~HOC';
import { changeLanguage } from '../../../actions/language';
import momentjs from 'moment-jalaali';
import './datePickersDropdown.scss';

const DatesPickerDropDown = (props) => {
  const {
    name,
    className,
    label,
    boxColor,
    disable = false,
    show,
    language: { direction },
    intl,
    parentClass,
    onClickTab,
    placement = 'end',
    resetDate = false,
    startDateData,
    endDateData,
    startDateLocalization = 'booking.startorderdate',
    endDateLocalization = 'booking.endorderdate',
    onChange,
    labelClassName = '',
    isGetTwoParams = false,
  } = props;
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    setStartDate('');
    setEndDate('');
  }, [resetDate]);

  useEffect(() => {
    setStartDate(startDateData);
    setEndDate(endDateData);
  }, []);

  const dateDisable = () => {
    let firstDate = '',
      secondDate = '';
    firstDate =
      startDate &&
      Number(
        momentjs(new Date(startDate).toLocaleDateString(), 'M/D/YYYY')
          .format('YYYY-MM-DD')
          ?.split('-')
          .join(''),
      );
    secondDate =
      endDate &&
      Number(
        momentjs(new Date(endDate).toLocaleDateString(), 'M/D/YYYY')
          .format('YYYY-MM-DD')
          ?.split('-')
          .join(''),
      );
    if (isGetTwoParams) {
      return (
        typeof secondDate !== 'number' ||
        typeof firstDate !== 'number' ||
        secondDate < firstDate
      );
    } else {
      return (
        (secondDate < firstDate && typeof secondDate === typeof firstDate) ||
        (!secondDate && !firstDate)
      );
    }
  };

  return (
    <div className={`filter-panel-container  dropdown ${className} `} id={name}>
      <div
        className={`col-11 h-100 filter-design d-flex flex-row justify-content-between px-2 ${
          direction === 'rtl' ? 'px-sm-3 px-2' : 'px-lg-3 px-sm-2 px-2'
        } ${boxColor} `}
        onClick={onClickTab}
      >
        <DateIcon variant="svg-md-small svg-sm-small svg-xs-small svg-tiny" />
        <span
          className={`font-xl-small font-md-smaller font-xsmall text-nowrap ${labelClassName}`}
        >
          <FormattedMessage id={label} />
        </span>
        <DownFillIcon variant="svg-md-small svg-sm-small svg-xs-small svg-tiny" />
      </div>
      {!disable && (
        <>
          <div
            className={`
					 d-flex
					 justify-content-sm-center ${parentClass} ${
              placement === 'center'
                ? 'justify-content-center'
                : 'justify-content-end'
            } align-items-center position-absolute w-100`}
            style={{ top: 48 }}
          >
            <div
              className={`col-11 m-2 dropdown-menu font-xl-normal font-sm-msmall font-smaller ${boxColor} datepickerDropDown-position shadow ${
                show && 'show'
              }`}
              style={{ zIndex: 1000 }}
            >
              <div className="p-3 mx-2">
                <div className="pb-3">
                  <div className="d-flex">
                    <DatePicker
                      themeMode="light"
                      name="startDate"
                      value={startDate}
                      placeholder={intl.formatMessage({
                        id: startDateLocalization,
                      })}
                      className="pt-4"
                      onChange={(date) => {
                        setStartDate(date ? date.split(',')[0] : null);
                      }}
                      inputClassName={'font-smaller'}
                      heightSize={'indropDown px-xl-0 px-3'}
                    />
                  </div>
                </div>
                <div>
                  <div className="d-flex">
                    <DatePicker
                      themeMode="light"
                      name="endOrderDate"
                      value={endDate}
                      placeholder={intl.formatMessage({
                        id: endDateLocalization,
                      })}
                      className="pt-4"
                      onChange={(date) => {
                        setEndDate(date ? date.split(',')[0] : null);
                      }}
                      inputClassName={'font-smaller'}
                      heightSize={'indropDown px-xl-0 px-3'}
                    />
                  </div>
                </div>
                <Button
                  name={`search-date-${name}`}
                  id={`search-date-${name}`}
                  label={intl.formatMessage({
                    id: 'profile.search',
                  })}
                  className="py-2 px-3 btn-secondary mt-4"
                  themeMode="light"
                  onClick={() => {
                    onChange({ startDate, endDate });
                  }}
                  disabled={dateDisable()}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}

export default injectIntl(
  connect(mapStateToProps, { changeLanguage })(withRouter(DatesPickerDropDown)),
);
